import type { TypedAddListener } from '@reduxjs/toolkit';
import {
  addListener as addListenerUntyped,
  createListenerMiddleware as rtkCreateListenerMiddleware,
} from '@reduxjs/toolkit';
import { Dispatch, State } from '../../client/configureStore';
import emptyListLoadedListener from './emptyListLoadedListener';
import {
  ListenerMiddleWareExtraArguments,
  StartListening,
} from './listenerMiddlewareTypes';
import { listOnRejectListener } from './listOnRejectListener';

export const addListener = addListenerUntyped as TypedAddListener<
  State,
  Dispatch,
  ListenerMiddleWareExtraArguments
>;

export const createListenerMiddleware = (
  extraArguments: ListenerMiddleWareExtraArguments
) => {
  const listenerMiddleware = rtkCreateListenerMiddleware({
    extra: extraArguments,
  });

  const startListening = listenerMiddleware.startListening as StartListening;

  startListening(emptyListLoadedListener);
  startListening(listOnRejectListener);

  return listenerMiddleware;
};
